import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetCountryRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetCountryResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setCountry = (request: SetCountryRequest, options?: CashRequestOptions) =>
  post<SetCountryRequest, SetCountryResponse>('/2.0/cash/set-country', request, { ...options, rejectOnError: true })
